module.exports = __webpack_public_path__ + "img/asklowcode-logo.b0b7cfcc.png";